export default __webpack_public_path__ + "static/media/post4.b180cd20.jpg";